/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WithdrawalRequestStatuses } from './withdrawal-request-statuses';


export interface WithdrawalRequestResponseItem { 
    withdrawalRequestId: string;
    userName: string;
    accountName: string;
    statusId: WithdrawalRequestStatuses;
    currencyName: string;
    currencyTicker: string;
    chainName: string;
    amount: number;
    commission: number;
    dailyWithdrawalAmount: number;
}



